export default __webpack_public_path__ + "static/media/Delivery.28cc3493.png";